import React, {Fragment, useEffect, useState} from 'react';
import Tabs from 'react-responsive-tabs';
import Template from "./Template";

let tabsContent = [
    {
        title: 'Email Template',
        content: <Template type = {"email"}/>,
    },
    {
        title: 'SMS Template',
        content: <Template type = {"sms"}/>,
    }
];

const CRMTemplates = (props) => {
    const [selectedTab, setSelectedTab] = useState(0);
    function getTabs() {
        return tabsContent.map((tab, index) => ({
            title: tab.title,
            getContent: () => tab.content,
            key: index,
        }));
    }
    const tabInfo = {'emailtemplates' : 0, 'smstemplates' : 1};
    useEffect(() => {
        let defaultSelectedTab = props.defaultSelectedTab;
        if(defaultSelectedTab !== undefined && defaultSelectedTab !== ""){
            setSelectedTab(tabInfo[defaultSelectedTab]);
        }
        return () => {
            // this now gets called when the component unmounts
        };

    }, []);
    return (
        <Fragment>
            <Tabs
                tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding"
                transform={false}
                showInkBar={true}
                selectedTabKey={selectedTab}
                items={getTabs()}/>
        </Fragment>
    )

}

export default CRMTemplates;
